import type { Dispatch, SetStateAction } from "react";

import { createStepStateContext } from "@/features/Generations/context/createStepStateContext";

export interface CollectionState {
  propagationSlug?: string;
}

export interface CollectionStateValue {
  collectionState: CollectionState;
  setCollectionState: Dispatch<SetStateAction<CollectionState>>;
}

const { Provider, useStepState } =
  createStepStateContext<CollectionState>("Collection");

export { Provider as CollectionStateProvider };

// eslint-disable-next-line react-refresh/only-export-components -- the hook belongs with the provider it reads
export function useCollectionState(): CollectionStateValue {
  const { state, setState } = useStepState();
  return { collectionState: state, setCollectionState: setState };
}
